

import { FC, ReactNode } from 'react';

import { LogoWrapper } from '@eneco/custom-components/flows/Navigation';
import { Box, Divider, EnecoLogo, OxxioLogo, WoonenergieLogo, NavLink, ProgressIndicator, Stack } from '@eneco/sparky';
import { ChevronLeftIcon } from '@eneco/sparky/icons';
import { DC_Repositories_Base_Enumerations_Label } from '@monorepo-types/dc';

interface Props {
  theme?: DC_Repositories_Base_Enumerations_Label;
  backLink?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  progressIndicatorItems?: {
    /** Identifies the step. Not its title, which is empty until the content arrives and need not be unique. */
    id: string;
    title: string;
    href?: string;
    onClick?: () => void;
    isActive?: boolean;
    isDisabled?: boolean;
  }[];
  children?: ReactNode;
}

const Logo: FC<{ theme?: DC_Repositories_Base_Enumerations_Label }> = ({ theme }) => {
  switch (theme) {
    case 'oxxio':
      return (
        <Box paddingTop="3">
          <OxxioLogo />
        </Box>
      );
    case 'woonenergie':
      return <WoonenergieLogo />;
    default:
      return <EnecoLogo />;
  }
};

export const NavigationBar: FC<Props> = ({ theme, backLink, progressIndicatorItems, children }) => (
  <Stack direction="column">
    <Stack as="nav" direction="row" alignY="center">
      {backLink && (
        <NavLink href={backLink.href} onClick={backLink.onClick} variant="secondary" leftIcon={<ChevronLeftIcon />}>
          {backLink.label}
        </NavLink>
      )}

      <Stack.Item grow={true}>
        <Stack direction="row" alignX="center">
          <LogoWrapper>
            <Logo theme={theme} />
          </LogoWrapper>
        </Stack>
      </Stack.Item>

      <Stack.Item>{children}</Stack.Item>
    </Stack>

    {progressIndicatorItems && (
      <>
        <Box>
          <Divider />
        </Box>

        <ProgressIndicator>
          {progressIndicatorItems.map(({ id, title, href, onClick, isActive, isDisabled }) => (
            <ProgressIndicator.Item
              key={id}
              href={href}
              onClick={onClick}
              isActive={isActive}
              isDisabled={isDisabled}>
              {title}
            </ProgressIndicator.Item>
          ))}
        </ProgressIndicator>
      </>
    )}
  </Stack>
);
